import apiServices from "../../ApiServices/request-handler";
import { languages } from "../../config/config";
import { requestHandler } from "../../utils/functions";
import { showToast } from "../../utils/utils";
import { setLanguage, setLanguageLoading } from "../slices/contentSlice";
import {
  setAccountReport,
  setGeneralClientDetails,
  setInvestmentReport,
  setInvestmentReportDropdown,
  setLanguages,
  setPasswordLoading,
  setResetLoading,
  setSettingLoading,
  setTicketingHistory,
  setTicketingHistoryLoading,
  setTradingSettingsDropdown,
} from "../slices/settingSlice";
import { logoutUser } from "./authActions";

export const getLanguages = (onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getLanguages,
        setData: setLanguages,
        onDone: onDone && onDone,
      })
    );
  };
};

export const changeLanguage = (langId, onDone) => {
  return async (dispatch) => {
    try {
      dispatch(setSettingLoading(true));
      dispatch(setLanguageLoading(true));
      const response = await apiServices.changeLanguage(langId);
      if (response?.status === true) {
        dispatch(
          setLanguage({
            language: langId === 3 ? languages.eng : languages.arb,
          })
        );
        dispatch(setSettingLoading(false));
        dispatch(setLanguageLoading(false));
        dispatch(getLanguages());
        showToast({
          icon: "success",
          title: response?.message,
        });
        onDone && onDone();
      } else {
        showToast({
          icon: "error",
          title: response?.data?.message ?? response?.message,
        });
        dispatch(setSettingLoading(false));
        dispatch(setLanguageLoading(false));
      }
    } catch (error) {
      showToast({
        icon: "error",
        title: error?.data?.message ?? error?.message,
      });
      dispatch(setSettingLoading(false));
      dispatch(setLanguageLoading(false));
    }
  };
};

export const changePassword = (data, navigate) => {
  return async (dispatch) => {
    try {
      dispatch(setPasswordLoading(true));
      const response = await apiServices.changePassword(data);
      dispatch(setPasswordLoading(false));
      if (response?.status) {
        showToast({
          icon: "success",
          title: response?.data?.message ?? response?.message,
        });
        dispatch(logoutUser(() => navigate('/login')));
      } else {
        showToast({
          icon: "error",
          title: response?.data?.message ?? response?.message,
        });
      }
    } catch (error) {
      showToast({
        icon: "error",
        title: error?.data?.message ?? error?.data?.title,
      });
      dispatch(setPasswordLoading(false));
    }
  };
};

export const getNotificationSetting = (onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getNotificationSetting,
        onDone: (data) => onDone(data?.result),
      })
    );
  };
};

export const changeNotificationSetting = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setSettingLoading,
        apiService: apiServices.changeNotificationSetting,
        param_data: data,
        isSuccessMessage: true,
        onDone: () => onDone(),
      })
    );
  };
};

export const resetNotificationSettings = (onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setResetLoading,
        apiService: apiServices.resetNotificationSettings,
        isSuccessMessage: true,
        onDone: () => onDone(),
      })
    );
  };
};

export const getTradingSettings = (onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getTradingSettings,
        onDone: (data) => onDone(data?.result),
      })
    );
  };
};

export const getTradingSettingsDropdown = () => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getTradingSettingsDropdown,
        setData: setTradingSettingsDropdown,
      })
    );
  };
};

export const changeTradingSettings = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setSettingLoading,
        apiService: apiServices.changeTradingSettings,
        param_data: data,
        onDone: () => onDone(),
      })
    );
  };
};

export const resetTradingSettings = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setResetLoading,
        apiService: apiServices.changeTradingSettings,
        param_data: data,
        onDone: () => onDone(),
      })
    );
  };
};

export const getAccountReport = (params) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setSettingLoading,
        apiService: apiServices.getAccountReport,
        param_data: params,
        setData: setAccountReport,
      })
    );
  };
};

export const getInvestmentReportDropdown = () => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getInvestmentReportDropdown,
        setData: setInvestmentReportDropdown,
      })
    );
  };
};

export const getInvestmentReport = (params) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setSettingLoading,
        apiService: apiServices.getInvestmentReport,
        param_data: params,
        setData: setInvestmentReport,
      })
    );
  };
};

export const createTicket = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setSettingLoading,
        apiService: apiServices.createTicket,
        param_data: data,
        isSuccessMessage: true,
        onDone: onDone,
      })
    );
  };
};

export const getGeneralClientDetail = () => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getGeneralClientDetail,
        setData: setGeneralClientDetails,
      })
    );
  };
};

// Ticketing
export const getTicketingHistory = (params) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getTicketingHistory,
        param_data: params,
        setLoading: setTicketingHistoryLoading,
        setData: setTicketingHistory,
      })
    );
  };
};

//Account Closure
export const submitAccountClosureRequest = (params, onDone, onError) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.submitAccountClosureRequest,
        param_data: params,
        setLoading: setSettingLoading,
        isSuccessMessage: true,
        onDone: () => onDone(),
        onError: () => onError(),
      })
    );
  };
};

// Update Vat Number
export const updateVatNumber = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.updateVatNumber,
        param_data: params,
        setLoading: setSettingLoading,
        isSuccessMessage: true,
        onDone: () => onDone(),
        // onError: () => onError(),
      })
    );
  };
};

